<template>
  <div>
      <div class="popover_header">
      
        <h2>Select A Fabric Suite</h2>
        <div class="popover_stroke"></div>
      </div>
      <div class="popover_body-fabric">

        <a v-for="setting in settings" v-bind:class="selected === setting.title.toLowerCase() ? 'active' : '' " @click.prevent="setFabric(setting.title.toLowerCase())" href="#">
          <img v-bind:src="setting.thumb" alt=""><span>{{setting.title}}</span>
        </a><!-- 
        <a v-bind:class="three ? 'active' : '' " @click.prevent="setFabric(3)" href="#">
          <img src="/static/img/fabric-raffia.jpg" alt=""> <span>Raffia</span>
        </a>
       
       
        <a v-bind:class="one ? 'active' : '' " @click.prevent="setFabric(1)" href="#">
          <img src="/static/img/fabric-toasted-almond.jpg" alt=""> <span>Toasted Almond </span>
        </a>

        <a v-bind:class="two ? 'active' : '' " @click.prevent="setFabric(2)" href="#">
          <img src="/static/img/fabric-zest.jpg" alt=""> <span>Zest</span>
        </a> -->

       

      </div>
      <div class="popover_footer"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      // fabric: null
    }
  },
  props: ['selected', 'settings'],
  computed: {
    one () { return this.selected === 1 },
    two () { return this.selected === 2 },
    three () { return this.selected === 3 }
  },
  methods: {
   setFabric (value) {
      // this.fabric = value
      this.$dispatch( 'fabric-changed', value )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




/** WEBPACK FOOTER **
 ** FabricControl.vue?35aebd54
 **/